import queryString from 'query-string'
import { getAxios } from '../../axiosWithToken'
import { notification } from 'antd'

export const getOrders = queryParams =>
  getAxios().get(`orders/?${queryString.stringify(queryParams)}`)

export const getNotPaidOrders = () => getAxios().get('orders/?is_paid=false')

export const patchOrder = (body, orderId) => {
  const copyBody = body
  copyBody.selected_shirt = [
    ...copyBody.selected_shirt,
    ...(copyBody.selected_undershirt || []),
    ...(copyBody.selected_buff || []),
    ...(copyBody.selected_v_shirt || []),
    ...(copyBody.selected_keychain || []),
    ...(copyBody.selected_1 || []),
    ...(copyBody.selected_2 || []),
    ...(copyBody.selected_3 || []),
    ...(copyBody.selected_4 || []),
    ...(copyBody.selected_5 || []),
    ...(copyBody.selected_6 || []),
    ...(copyBody.selected_7 || []),
    ...(copyBody.selected_8 || []),
    ...(copyBody.selected_9 || []),
    ...(copyBody.selected_10 || []),
    ...(copyBody.selected_11 || []),
    ...(copyBody.selected_12 || []),
    ...(copyBody.selected_13 || []),
    ...(copyBody.selected_14 || [])
  ]
  copyBody.selected_shirt = copyBody.selected_shirt.filter(i => i)
  return getAxios()
    .patch(`orders/${orderId}`, copyBody)
    .catch(e => {
      notification.error({
        message: Object.entries(e.response.data)
          .map(x => x.join(':'))
          .join('\r\n')
      })
      return Promise.reject(e)
    })
}



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/orders/index.js